import axios from 'axios';
import { get } from 'svelte/store';

import { accessToken } from './stores.js';

axios.defaults.withCredentials=true;
axios.defaults.crossDomain=true;

let debug = false;
let baseURL = 'https://api.attendzen.io/';

if ((window.location.hostname == 'localhost') || (window.location.hostname == 'dev--attendzen-studio.netlify.app')) {
	console.log('Using dev API');
	baseURL = 'https://api-dev.attendzen.io/';
	debug = true;
}

const prelude = axios.create({
	baseURL: baseURL,
	timeout: 100000,
});

export const getServerData = async (endpoint, params) => {

	try {

		if (!params) params = {};
		params['accessToken'] = get(accessToken);

		const response = await prelude({
			url: endpoint,
			method: "GET",
			params: params
		});

		if (debug) console.log('data', 'GET', endpoint, response.data, new Date().toISOString());

		return response.data;

	} catch (err) {

		return null;

	}

}

export const postServerData = async (endpoint, params) => {

	let formData = new FormData();

	let token = get(accessToken);
	formData.append('accessToken', token);

	if (params) {
		for (let [key, value] of Object.entries(params)) {
			formData.append(key, value);
		}
	}

	try {

		const response = await prelude({
			url: endpoint,
			method: "POST",
			data: formData
		});

		return response.data;

	} catch (err) {

		console.error(err);

		return null;

	}

}